import client from './client';
export const getProfile = () => {
	return client.get('/profile');
};
